import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthStore } from './core/auth/services/auth.store';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { TranslatePipe } from './shared/pipes/translate.pipe';
import { TranslateService } from './shared/services/translate.service';
import { isEmpty } from './shared/helpers/utils.helpers';
import { APP_CONFIG } from './app.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  env = { ...APP_CONFIG };

  constructor(
    private authStore: AuthStore,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private translator: TranslatePipe,
    private translation: TranslateService
  ) {}

  ngOnDestroy() {}

  ngOnInit() {
    this.authStore.init();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        tap(() => {
          let currentRoute = this.route.root;
          let title = '';
          do {
            const childrenRoutes = currentRoute.children;
            currentRoute = null;
            childrenRoutes.forEach((routes) => {
              if (routes.outlet === 'primary') {
                title = routes.snapshot.data.breadcrumb;
                currentRoute = routes;
              }
            });
          } while (currentRoute);
          if (!this.translation.getLocale()) {
            this.translation
              .use(localStorage.getItem('locale') == 'fr' ? 'en' : localStorage.getItem('locale'))
              .then(() => {
                this.titleService.setTitle(
                  this.env.appName + ' ' + (isEmpty(title) ? '' : ' - ' + this.translator.transform(title))
                );
              });
          } else {
            this.titleService.setTitle(
              this.env.appName + ' ' + (isEmpty(title) ? '' : ' - ' + this.translator.transform(title))
            );
          }
        })
      )
      .subscribe();
  }

  onActivate(event) {
    window.scroll(0, 0);
    document.getElementsByTagName('body')[0].classList.remove('route-loading');
  }
}
